import * as React from "react";
import { cn } from "../lib/utils";

interface ConnectorFormDetailsProps {
  summary: React.ReactNode;
  children: React.ReactNode;
  defaultOpen?: boolean;
  className?: string;
  summaryClassName?: string;
  contentClassName?: string;
}

function ConnectorFormDetails({
  summary,
  children,
  defaultOpen = false,
  className,
  summaryClassName,
  contentClassName,
}: ConnectorFormDetailsProps) {
  return (
    <details className={className} open={defaultOpen}>
      <summary
        className={cn(
          "cursor-pointer px-3 py-2 text-sm text-muted-foreground hover:text-foreground",
          summaryClassName,
        )}
      >
        {summary}
      </summary>
      <div className={cn("space-y-4 border-t border-border/50 px-3 py-3", contentClassName)}>
        {children}
      </div>
    </details>
  );
}

export { ConnectorFormDetails };
export type { ConnectorFormDetailsProps };
